import { useState } from 'react';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { FRAGMENT_COLORS } from '@/lib/utils';
import { Palette, Check } from 'lucide-react';

export default function ColorPicker({ value, onChange, className = '' }) {
    const [open, setOpen] = useState(false);

    const handleSelect = (colorId) => {
        onChange(colorId === 'default' ? null : colorId);
        // Don't close - stays open until user clicks Done or outside
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button
                    className={`h-8 w-8 rounded-md flex items-center justify-center transition-all duration-150 bg-background border border-border shadow-sm hover:bg-muted hover:border-primary/40 ${className}`}
                    title="Change color"
                >
                    <Palette className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
                </button>
            </PopoverTrigger>
            <PopoverContent 
                className="w-auto p-3 animate-scale-in" 
                align="end"
                sideOffset={8}
            >
                <div className="flex flex-col gap-2">
                    <p className="text-xs text-muted-foreground font-medium">Fragment Color</p>
                    <div className="grid grid-cols-5 gap-2">
                        {FRAGMENT_COLORS.map((color) => (
                            <button
                                key={color.id}
                                onClick={() => handleSelect(color.id)}
                                className={`relative w-7 h-7 rounded-full flex items-center justify-center transition-all duration-150 ring-1 ring-inset ${
                                    (value === color.id) || (!value && color.id === 'default')
                                        ? 'ring-primary ring-2'
                                        : 'ring-border/50 hover:ring-border'
                                }`}
                                style={color.cssVar 
                                    ? { backgroundColor: `hsl(var(${color.cssVar}))` }
                                    : { backgroundColor: 'transparent' }
                                }
                                title={color.label}
                            >
                                {color.id === 'default' && (
                                    <div className="w-4 h-4 rounded-full border border-dashed border-muted-foreground/60" />
                                )}
                                {((value === color.id) || (!value && color.id === 'default')) && (
                                    <Check 
                                        className={`w-3.5 h-3.5 absolute ${
                                            color.id === 'default' ? 'text-muted-foreground' : 'text-foreground/60'
                                        }`} 
                                        strokeWidth={2.5}
                                    />
                                )}
                            </button>
                        ))}
                    </div>
                    <Button 
                        variant="ghost" 
                        size="sm" 
                        onClick={() => setOpen(false)}
                        className="mt-1 h-7 text-xs"
                    >
                        Done
                    </Button>
                </div>
            </PopoverContent>
        </Popover>
    );
}